var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#FEF2F2",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6C8.58579 6 8.25 6.33579 8.25 6.75V7.5H7.5C6.67157 7.5 6 8.17157 6 9V16.5C6 17.3284 6.67157 18 7.5 18H16.5C17.3284 18 18 17.3284 18 16.5V9C18 8.17157 17.3284 7.5 16.5 7.5H15.75V6.75C15.75 6.33579 15.4142 6 15 6C14.5858 6 14.25 6.33579 14.25 6.75V7.5H9.75V6.75C9.75 6.33579 9.41421 6 9 6ZM9.17157 9.83829C9.43192 9.57794 9.85403 9.57794 10.1144 9.83829L12 11.7239L13.8856 9.83833C14.146 9.57798 14.5681 9.57798 14.8284 9.83833C15.0888 10.0987 15.0888 10.5208 14.8284 10.7811L12.9428 12.6667L14.8284 14.5523C15.0888 14.8127 15.0888 15.2348 14.8284 15.4951C14.5681 15.7555 14.146 15.7555 13.8856 15.4951L12 13.6095L10.1144 15.4952C9.85403 15.7555 9.43192 15.7555 9.17157 15.4952C8.91122 15.2348 8.91122 14.8127 9.17157 14.5524L11.0572 12.6667L9.17157 10.7811C8.91122 10.5208 8.91122 10.0986 9.17157 9.83829Z",
    fill: "#B91C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClose);
export default __webpack_public_path__ + "static/media/calendar-close.7b3f2cd04eb8bf67503ee94f888a6f82.svg";
export { ForwardRef as ReactComponent };